import BaseService from "./BaseService";

class EnterpriseService {
  static async list(data) {
    const params = BaseService.cleanQueryParams(data);
    const queryParams = new URLSearchParams(params).toString();
    return await BaseService.callAPI(`/enterprises?${queryParams}`);
  }

  static async create({ data, logo }) {
    const formData = new FormData();
    formData.append("logo", logo);

    const artifactResponse = await BaseService.callAPI(
      `/enterprises/logo`,
      "POST",
      formData,
      {},
      { contentType: "multipart/form-data" }
    );

    data.logo = artifactResponse.data.response.id;

    return await BaseService.callAPI(`/enterprises`, "POST", data);
  }

  static async details({ id }) {
    return await BaseService.callAPI(`/enterprises/${id}`);
  }

  static async update(data) {
    return await BaseService.callAPI(`/enterprises/${data.id}`, "PUT", data);
  }

  static async selfEnterpriseUpdate(data) {
    return await BaseService.callAPI(`/enterprise`, "POST", data);
  }

  static async selfEnterpriseSMTPDetails() {
    return await BaseService.callAPI(`/enterprise/smtp`);
  }

  static async selfEmailBannerDetails() {
    return await BaseService.callAPI(`/enterprise/email/banners`);
  }

  static async selfEmailBannerUpdateDetails(data) {
    return await BaseService.callAPI(`/enterprise/email/banners`, "POST", data);
  }

  static async selfEnterpriseSMTPUpdate(data) {
    return await BaseService.callAPI(`/enterprise/smtp`, "POST", data);
  }

  static async selfLearnerConfiguration() {
    return await BaseService.callAPI(`/enterprise/learner/configuration`);
  }

  static async selfLanguageConfiguration() {
    return await BaseService.callAPI(`/enterprise/language/configuration`);
  }

  static async updateSelfLanguageConfiguration(data) {
    return await BaseService.callAPI(
      `/enterprise/language/configuration`,
      "POST",
      data
    );
  }

  static async updateSelfLearnerConfiguration(data) {
    return await BaseService.callAPI(
      `/enterprise/learner/configuration`,
      "POST",
      data
    );
  }

  static async getDomainDetails(subdomain) {
    return await BaseService.callAPI(
      `/domain?domain=${subdomain}`,
      "GET",
      null,
      null,
      null,
      true
    );
  }
}

export default EnterpriseService;
